import cn from 'classnames';

import Check from 'components/icons/accent/Check';
import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const CheckboxCard = ({
  iconClassName = 'w-12 mb-1',
  styleRefresh = false,
  checked,
  description,
  iconComponent,
  inputName,
  item,
  onClick,
  hideCheckmark = false,
  labelClassName = 'mx-3 mb-0 px-2 bp1:mx-0',
  selectedStandardBorderClassName = 'border-green-100',
  selectedTempoTextClassName = 'text-tempo-black-100',
  selectedTextClassName = '!text-green-110',
  selectedTempoBorderClassName = 'border-tempo-navy-100',
  textClassName = '',
  borderClassName = 'border-charcoal-60',
}) => {
  const IconComponent = iconComponent;
  const isTempo = useBrand(TEMPO);

  return (
    <label
      data-testid={`${item.name}-option`}
      className={cn(
        `relative flex cursor-pointer flex-col items-center justify-center rounded border-solid text-center ${labelClassName}`,
        {
          'rounded-pill border-charcoal-100': styleRefresh,
          [`border-2 ${selectedStandardBorderClassName}`]: checked && !isTempo,
          [`border-2 ${selectedTempoBorderClassName}`]: checked && isTempo,
          [`border ${borderClassName}`]: !checked,
          'bg-green-50': checked && styleRefresh && !isTempo,
          'bg-tempo-blue-10': checked && styleRefresh && isTempo,
          checkedInput: checked,
        }
      )}
    >
      <input
        onChange={() => onClick(item)}
        value={item.name}
        checked={checked}
        type="checkbox"
        className="sr-only"
        name={inputName}
      />
      {!hideCheckmark &&
        (styleRefresh ? (
          <span className="radioInput absolute -top-1.5 right-0 mr-0.5 h-6 min-w-6 rounded-full border-none p-0">
            {checked && <Check className="directional-center absolute text-white-100" />}
          </span>
        ) : (
          <span className="checkboxInput absolute right-0 top-0 mt-3">
            <Check className="directional-center absolute text-white-100" />
          </span>
        ))}

      {iconComponent ? (
        <IconComponent
          className={iconClassName}
          hcSelected={!isTempo && checked}
          tempoSelected={isTempo && checked}
        />
      ) : null}
      <span
        className={cn(`textMd select-none ${textClassName}`, {
          [selectedTextClassName]: checked && styleRefresh && !isTempo,
          [selectedTempoTextClassName]: checked && styleRefresh && isTempo,
        })}
      >
        {item.name}
      </span>
      {description ? (
        <span className="textSm max-w-64 select-none italic">{description}</span>
      ) : null}
    </label>
  );
};

CheckboxCard.propTypes = {
  checked: PropTypes.bool.isRequired,
  inputName: PropTypes.string.isRequired,
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  hideCheckmark: PropTypes.bool,
  iconComponent: PropTypes.elementType,
  description: PropTypes.string,
  iconClassName: PropTypes.string,
  styleRefresh: PropTypes.bool,
  labelClassName: PropTypes.string,
  selectedTempoTextClassName: PropTypes.string,
  selectedTextClassName: PropTypes.string,
  selectedStandardBorderClassName: PropTypes.string,
  selectedTempoBorderClassName: PropTypes.string,
  textClassName: PropTypes.string,
  borderClassName: PropTypes.string,
};

export default CheckboxCard;
